import { docCodes } from "../../../../data/docCodes";
import { levelExcude, versionsAccess } from "../../../../data/main";
import { sectionsList } from "../../../../data/sectionsList";
import { stdObject } from "../../../../data/types/stdObject";
import { versionsType } from "../../../../data/types/versionsType";
import { sendData } from "../../../../services/sendData";

export const openRolInfo = async (data: stdObject, params: stdObject) => {
  const { id, index } = data;
  const {
    t,
    setMsg,
    setModalData,
    setModalData2,
    setWindowValues,
    logoutAction,
  } = params;
  const cVersion = process.env.REACT_APP_VERSION as versionsType;
  const level = process.env.REACT_APP_VERSION_LEVEL as string;
  setMsg("loading");
  const payloadRolInfo = { id };
  console.log("payloadRolInfo: ", payloadRolInfo);
  const resultRolInfo: stdObject = await sendData({
    endPoint: "callRol",
    payload: payloadRolInfo,
    logoutAction,
  });
  console.log("resultRolInfo: ", resultRolInfo);
  if (resultRolInfo.success) {
    setMsg("rolInfoModal");
    setModalData({
      title: id === "" ? t("p.newROL") : resultRolInfo.info.NOMROL,
      type: "ROL",
      id,
      index,
      tabs: resultRolInfo.tabs,
    });

    resultRolInfo.precios = Object.entries(resultRolInfo.precios).reduce(
      (acc: stdObject, curr: [string, any]) => {
        const key = Object.keys(docCodes).find((key) =>
          curr[0].startsWith(docCodes[key]),
        );
        const isNumber = key ? key.replace(/[A-Z]/g, "") : false;

        return typeof key === "string" &&
          versionsAccess[cVersion].includes(key[0])
          ? isNumber &&
            isNumber !== "" &&
            levelExcude[cVersion][level][key[0]].includes(Number(isNumber))
            ? acc
            : { ...acc, [curr[0]]: curr[1] }
          : acc;
      },
      {},
    );

    sectionsList.forEach((e: stdObject) => {
      if (versionsAccess[cVersion].includes(e.id)) {
        resultRolInfo[e.id.toLowerCase()] = Object.entries(
          resultRolInfo[e.id.toLowerCase()],
        ).reduce((acc: stdObject, curr: [string, any]) => {
          const isNumber = curr[0].replace(/[A-Z]/g, "");
          return isNumber !== "" &&
            levelExcude[cVersion][level][e.id].includes(Number(isNumber))
            ? acc
            : { ...acc, [curr[0]]: curr[1] };
        }, {});
      } else {
        delete resultRolInfo[e.id.toLowerCase()];
      }
    });

    let newRolValues: stdObject = {};
    [
      "info",
      "precios",
      "tarifas",
      "v",
      "a",
      "b",
      "c",
      "d",
      "e",
      "f",
      "g",
      "z",
      "ip",
    ].forEach((e: string) => {
      if (e === "info") {
        newRolValues[e] = resultRolInfo[e] ?? {};
      } else if (e in resultRolInfo) {
        newRolValues[e] = resultRolInfo[e];
      }
    });
    setWindowValues(newRolValues);
  } else {
    setModalData2({ label: resultRolInfo.error });
    setMsg("error");
  }
};
